import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: any;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: any;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: any;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  classCollection?: Maybe<ClassCollection>;
  entryCollection?: Maybe<EntryCollection>;
  teacherCollection?: Maybe<TeacherCollection>;
};


export type AssetLinkingCollectionsClassCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTeacherCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type Class = Entry & {
  __typename?: 'Class';
  beid?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  herovideostart?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  intensity?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ClassLinkingCollections>;
  liveStreamEndsAt?: Maybe<Scalars['DateTime']>;
  liveStreamStartsAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  spotifyPlaylistUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  sys: Sys;
  tags?: Maybe<Scalars['String']>;
  teacher?: Maybe<Teacher>;
  type?: Maybe<Scalars['String']>;
  videoseconds?: Maybe<Scalars['Int']>;
  viewCount?: Maybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassBeidArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassClassificationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassDurationInMinutesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassHerovideostartArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassIntensityArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassIsPublicArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassLevelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassLiveStreamEndsAtArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassLiveStreamStartsAtArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassPublishedAtArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassSpotifyPlaylistUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassStatusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassSubtypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassTagsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassTeacherArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassVideosecondsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/class) */
export type ClassViewCountArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ClassCollection = {
  __typename?: 'ClassCollection';
  items: Array<Maybe<Class>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ClassFilter = {
  AND?: InputMaybe<Array<InputMaybe<ClassFilter>>>;
  BEID?: InputMaybe<Scalars['String']>;
  BEID_contains?: InputMaybe<Scalars['String']>;
  BEID_exists?: InputMaybe<Scalars['Boolean']>;
  BEID_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  BEID_not?: InputMaybe<Scalars['String']>;
  BEID_not_contains?: InputMaybe<Scalars['String']>;
  BEID_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  OR?: InputMaybe<Array<InputMaybe<ClassFilter>>>;
  classification?: InputMaybe<Scalars['String']>;
  classification_contains?: InputMaybe<Scalars['String']>;
  classification_exists?: InputMaybe<Scalars['Boolean']>;
  classification_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_not?: InputMaybe<Scalars['String']>;
  classification_not_contains?: InputMaybe<Scalars['String']>;
  classification_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName?: InputMaybe<Scalars['String']>;
  displayName_contains?: InputMaybe<Scalars['String']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName_not?: InputMaybe<Scalars['String']>;
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  durationInMinutes_exists?: InputMaybe<Scalars['Boolean']>;
  durationInMinutes_gt?: InputMaybe<Scalars['Int']>;
  durationInMinutes_gte?: InputMaybe<Scalars['Int']>;
  durationInMinutes_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  durationInMinutes_lt?: InputMaybe<Scalars['Int']>;
  durationInMinutes_lte?: InputMaybe<Scalars['Int']>;
  durationInMinutes_not?: InputMaybe<Scalars['Int']>;
  durationInMinutes_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  herovideostart?: InputMaybe<Scalars['Int']>;
  herovideostart_exists?: InputMaybe<Scalars['Boolean']>;
  herovideostart_gt?: InputMaybe<Scalars['Int']>;
  herovideostart_gte?: InputMaybe<Scalars['Int']>;
  herovideostart_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  herovideostart_lt?: InputMaybe<Scalars['Int']>;
  herovideostart_lte?: InputMaybe<Scalars['Int']>;
  herovideostart_not?: InputMaybe<Scalars['Int']>;
  herovideostart_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  intensity?: InputMaybe<Scalars['String']>;
  intensity_contains?: InputMaybe<Scalars['String']>;
  intensity_exists?: InputMaybe<Scalars['Boolean']>;
  intensity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  intensity_not?: InputMaybe<Scalars['String']>;
  intensity_not_contains?: InputMaybe<Scalars['String']>;
  intensity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isPublic_exists?: InputMaybe<Scalars['Boolean']>;
  isPublic_not?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['String']>;
  level_contains?: InputMaybe<Scalars['String']>;
  level_exists?: InputMaybe<Scalars['Boolean']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  level_not?: InputMaybe<Scalars['String']>;
  level_not_contains?: InputMaybe<Scalars['String']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liveStreamEndsAt?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_exists?: InputMaybe<Scalars['Boolean']>;
  liveStreamEndsAt_gt?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_gte?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  liveStreamEndsAt_lt?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_lte?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_not?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  liveStreamStartsAt?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_exists?: InputMaybe<Scalars['Boolean']>;
  liveStreamStartsAt_gt?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_gte?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  liveStreamStartsAt_lt?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_lte?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_not?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  spotifyPlaylistUrl?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_contains?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_exists?: InputMaybe<Scalars['Boolean']>;
  spotifyPlaylistUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spotifyPlaylistUrl_not?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_not_contains?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  status_contains?: InputMaybe<Scalars['String']>;
  status_exists?: InputMaybe<Scalars['Boolean']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status_not?: InputMaybe<Scalars['String']>;
  status_not_contains?: InputMaybe<Scalars['String']>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtype?: InputMaybe<Scalars['String']>;
  subtype_contains?: InputMaybe<Scalars['String']>;
  subtype_exists?: InputMaybe<Scalars['Boolean']>;
  subtype_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtype_not?: InputMaybe<Scalars['String']>;
  subtype_not_contains?: InputMaybe<Scalars['String']>;
  subtype_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tags?: InputMaybe<Scalars['String']>;
  tags_contains?: InputMaybe<Scalars['String']>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_not?: InputMaybe<Scalars['String']>;
  tags_not_contains?: InputMaybe<Scalars['String']>;
  tags_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teacher?: InputMaybe<CfTeacherNestedFilter>;
  teacher_exists?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoseconds?: InputMaybe<Scalars['Int']>;
  videoseconds_exists?: InputMaybe<Scalars['Boolean']>;
  videoseconds_gt?: InputMaybe<Scalars['Int']>;
  videoseconds_gte?: InputMaybe<Scalars['Int']>;
  videoseconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  videoseconds_lt?: InputMaybe<Scalars['Int']>;
  videoseconds_lte?: InputMaybe<Scalars['Int']>;
  videoseconds_not?: InputMaybe<Scalars['Int']>;
  videoseconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  viewCount?: InputMaybe<Scalars['Int']>;
  viewCount_exists?: InputMaybe<Scalars['Boolean']>;
  viewCount_gt?: InputMaybe<Scalars['Int']>;
  viewCount_gte?: InputMaybe<Scalars['Int']>;
  viewCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  viewCount_lt?: InputMaybe<Scalars['Int']>;
  viewCount_lte?: InputMaybe<Scalars['Int']>;
  viewCount_not?: InputMaybe<Scalars['Int']>;
  viewCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ClassLinkingCollections = {
  __typename?: 'ClassLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  featureClassCollection?: Maybe<FeatureClassCollection>;
};


export type ClassLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ClassLinkingCollectionsFeatureClassCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ClassOrder {
  BeidAsc = 'BEID_ASC',
  BeidDesc = 'BEID_DESC',
  ClassificationAsc = 'classification_ASC',
  ClassificationDesc = 'classification_DESC',
  DisplayNameAsc = 'displayName_ASC',
  DisplayNameDesc = 'displayName_DESC',
  DurationInMinutesAsc = 'durationInMinutes_ASC',
  DurationInMinutesDesc = 'durationInMinutes_DESC',
  HerovideostartAsc = 'herovideostart_ASC',
  HerovideostartDesc = 'herovideostart_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IntensityAsc = 'intensity_ASC',
  IntensityDesc = 'intensity_DESC',
  IsPublicAsc = 'isPublic_ASC',
  IsPublicDesc = 'isPublic_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  LiveStreamEndsAtAsc = 'liveStreamEndsAt_ASC',
  LiveStreamEndsAtDesc = 'liveStreamEndsAt_DESC',
  LiveStreamStartsAtAsc = 'liveStreamStartsAt_ASC',
  LiveStreamStartsAtDesc = 'liveStreamStartsAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SpotifyPlaylistUrlAsc = 'spotifyPlaylistUrl_ASC',
  SpotifyPlaylistUrlDesc = 'spotifyPlaylistUrl_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SubtypeAsc = 'subtype_ASC',
  SubtypeDesc = 'subtype_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TagsAsc = 'tags_ASC',
  TagsDesc = 'tags_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  VideosecondsAsc = 'videoseconds_ASC',
  VideosecondsDesc = 'videoseconds_DESC',
  ViewCountAsc = 'viewCount_ASC',
  ViewCountDesc = 'viewCount_DESC'
}

/** categories available for a given classification [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/classificationCategories) */
export type ClassificationCategories = Entry & {
  __typename?: 'ClassificationCategories';
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  classification?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  defaultIndex?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<ClassificationCategoriesLinkingCollections>;
  sys: Sys;
};


/** categories available for a given classification [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/classificationCategories) */
export type ClassificationCategoriesCategoriesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** categories available for a given classification [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/classificationCategories) */
export type ClassificationCategoriesClassificationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** categories available for a given classification [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/classificationCategories) */
export type ClassificationCategoriesDefaultIndexArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** categories available for a given classification [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/classificationCategories) */
export type ClassificationCategoriesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ClassificationCategoriesCollection = {
  __typename?: 'ClassificationCategoriesCollection';
  items: Array<Maybe<ClassificationCategories>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ClassificationCategoriesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ClassificationCategoriesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ClassificationCategoriesFilter>>>;
  categories_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categories_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categories_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categories_exists?: InputMaybe<Scalars['Boolean']>;
  classification?: InputMaybe<Scalars['String']>;
  classification_contains?: InputMaybe<Scalars['String']>;
  classification_exists?: InputMaybe<Scalars['Boolean']>;
  classification_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_not?: InputMaybe<Scalars['String']>;
  classification_not_contains?: InputMaybe<Scalars['String']>;
  classification_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultIndex?: InputMaybe<Scalars['Int']>;
  defaultIndex_exists?: InputMaybe<Scalars['Boolean']>;
  defaultIndex_gt?: InputMaybe<Scalars['Int']>;
  defaultIndex_gte?: InputMaybe<Scalars['Int']>;
  defaultIndex_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultIndex_lt?: InputMaybe<Scalars['Int']>;
  defaultIndex_lte?: InputMaybe<Scalars['Int']>;
  defaultIndex_not?: InputMaybe<Scalars['Int']>;
  defaultIndex_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ClassificationCategoriesLinkingCollections = {
  __typename?: 'ClassificationCategoriesLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ClassificationCategoriesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ClassificationCategoriesOrder {
  ClassificationAsc = 'classification_ASC',
  ClassificationDesc = 'classification_DESC',
  DefaultIndexAsc = 'defaultIndex_ASC',
  DefaultIndexDesc = 'defaultIndex_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataFilter = {
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/featureClass) */
export type FeatureClass = Entry & {
  __typename?: 'FeatureClass';
  class?: Maybe<Class>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FeatureClassLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/featureClass) */
export type FeatureClassClassArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/featureClass) */
export type FeatureClassLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/featureClass) */
export type FeatureClassNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type FeatureClassCollection = {
  __typename?: 'FeatureClassCollection';
  items: Array<Maybe<FeatureClass>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FeatureClassFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeatureClassFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeatureClassFilter>>>;
  class?: InputMaybe<CfClassNestedFilter>;
  class_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FeatureClassLinkingCollections = {
  __typename?: 'FeatureClassLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type FeatureClassLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FeatureClassOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

export type Query = {
  __typename?: 'Query';
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  class?: Maybe<Class>;
  classCollection?: Maybe<ClassCollection>;
  classificationCategories?: Maybe<ClassificationCategories>;
  classificationCategoriesCollection?: Maybe<ClassificationCategoriesCollection>;
  entryCollection?: Maybe<EntryCollection>;
  featureClass?: Maybe<FeatureClass>;
  featureClassCollection?: Maybe<FeatureClassCollection>;
  teacher?: Maybe<Teacher>;
  teacherCollection?: Maybe<TeacherCollection>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryClassArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryClassCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ClassOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClassFilter>;
};


export type QueryClassificationCategoriesArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryClassificationCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ClassificationCategoriesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClassificationCategoriesFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryFeatureClassArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFeatureClassCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FeatureClassOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeatureClassFilter>;
};


export type QueryTeacherArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTeacherCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeacherOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeacherFilter>;
};

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type Teacher = Entry & {
  __typename?: 'Teacher';
  beid?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  heroImage?: Maybe<Asset>;
  image?: Maybe<Asset>;
  image43?: Maybe<Asset>;
  lastName?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TeacherLinkingCollections>;
  slug?: Maybe<Scalars['String']>;
  sys: Sys;
  videoUrl?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherBeidArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherCountryArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherFirstNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherGenderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherHeroImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherImage43Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherLastNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/ucjxsxygu9fz/content_types/teacher) */
export type TeacherVideoUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TeacherCollection = {
  __typename?: 'TeacherCollection';
  items: Array<Maybe<Teacher>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TeacherFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeacherFilter>>>;
  BEID?: InputMaybe<Scalars['String']>;
  BEID_contains?: InputMaybe<Scalars['String']>;
  BEID_exists?: InputMaybe<Scalars['Boolean']>;
  BEID_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  BEID_not?: InputMaybe<Scalars['String']>;
  BEID_not_contains?: InputMaybe<Scalars['String']>;
  BEID_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  OR?: InputMaybe<Array<InputMaybe<TeacherFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  country?: InputMaybe<Scalars['String']>;
  country_contains?: InputMaybe<Scalars['String']>;
  country_exists?: InputMaybe<Scalars['Boolean']>;
  country_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_not?: InputMaybe<Scalars['String']>;
  country_not_contains?: InputMaybe<Scalars['String']>;
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName?: InputMaybe<Scalars['String']>;
  displayName_contains?: InputMaybe<Scalars['String']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName_not?: InputMaybe<Scalars['String']>;
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  firstName_exists?: InputMaybe<Scalars['Boolean']>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName_not?: InputMaybe<Scalars['String']>;
  firstName_not_contains?: InputMaybe<Scalars['String']>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender?: InputMaybe<Scalars['String']>;
  gender_contains?: InputMaybe<Scalars['String']>;
  gender_exists?: InputMaybe<Scalars['Boolean']>;
  gender_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender_not?: InputMaybe<Scalars['String']>;
  gender_not_contains?: InputMaybe<Scalars['String']>;
  gender_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  heroImage_exists?: InputMaybe<Scalars['Boolean']>;
  image43_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  lastName_exists?: InputMaybe<Scalars['Boolean']>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastName_not?: InputMaybe<Scalars['String']>;
  lastName_not_contains?: InputMaybe<Scalars['String']>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  videoUrl?: InputMaybe<Scalars['String']>;
  videoUrl_contains?: InputMaybe<Scalars['String']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeacherLinkingCollections = {
  __typename?: 'TeacherLinkingCollections';
  classCollection?: Maybe<ClassCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type TeacherLinkingCollectionsClassCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeacherLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TeacherOrder {
  BeidAsc = 'BEID_ASC',
  BeidDesc = 'BEID_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  DisplayNameAsc = 'displayName_ASC',
  DisplayNameDesc = 'displayName_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  GenderAsc = 'gender_ASC',
  GenderDesc = 'gender_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type CfClassNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfClassNestedFilter>>>;
  BEID?: InputMaybe<Scalars['String']>;
  BEID_contains?: InputMaybe<Scalars['String']>;
  BEID_exists?: InputMaybe<Scalars['Boolean']>;
  BEID_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  BEID_not?: InputMaybe<Scalars['String']>;
  BEID_not_contains?: InputMaybe<Scalars['String']>;
  BEID_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  OR?: InputMaybe<Array<InputMaybe<CfClassNestedFilter>>>;
  classification?: InputMaybe<Scalars['String']>;
  classification_contains?: InputMaybe<Scalars['String']>;
  classification_exists?: InputMaybe<Scalars['Boolean']>;
  classification_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_not?: InputMaybe<Scalars['String']>;
  classification_not_contains?: InputMaybe<Scalars['String']>;
  classification_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName?: InputMaybe<Scalars['String']>;
  displayName_contains?: InputMaybe<Scalars['String']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName_not?: InputMaybe<Scalars['String']>;
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  durationInMinutes_exists?: InputMaybe<Scalars['Boolean']>;
  durationInMinutes_gt?: InputMaybe<Scalars['Int']>;
  durationInMinutes_gte?: InputMaybe<Scalars['Int']>;
  durationInMinutes_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  durationInMinutes_lt?: InputMaybe<Scalars['Int']>;
  durationInMinutes_lte?: InputMaybe<Scalars['Int']>;
  durationInMinutes_not?: InputMaybe<Scalars['Int']>;
  durationInMinutes_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  herovideostart?: InputMaybe<Scalars['Int']>;
  herovideostart_exists?: InputMaybe<Scalars['Boolean']>;
  herovideostart_gt?: InputMaybe<Scalars['Int']>;
  herovideostart_gte?: InputMaybe<Scalars['Int']>;
  herovideostart_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  herovideostart_lt?: InputMaybe<Scalars['Int']>;
  herovideostart_lte?: InputMaybe<Scalars['Int']>;
  herovideostart_not?: InputMaybe<Scalars['Int']>;
  herovideostart_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  intensity?: InputMaybe<Scalars['String']>;
  intensity_contains?: InputMaybe<Scalars['String']>;
  intensity_exists?: InputMaybe<Scalars['Boolean']>;
  intensity_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  intensity_not?: InputMaybe<Scalars['String']>;
  intensity_not_contains?: InputMaybe<Scalars['String']>;
  intensity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isPublic_exists?: InputMaybe<Scalars['Boolean']>;
  isPublic_not?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['String']>;
  level_contains?: InputMaybe<Scalars['String']>;
  level_exists?: InputMaybe<Scalars['Boolean']>;
  level_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  level_not?: InputMaybe<Scalars['String']>;
  level_not_contains?: InputMaybe<Scalars['String']>;
  level_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  liveStreamEndsAt?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_exists?: InputMaybe<Scalars['Boolean']>;
  liveStreamEndsAt_gt?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_gte?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  liveStreamEndsAt_lt?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_lte?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_not?: InputMaybe<Scalars['DateTime']>;
  liveStreamEndsAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  liveStreamStartsAt?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_exists?: InputMaybe<Scalars['Boolean']>;
  liveStreamStartsAt_gt?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_gte?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  liveStreamStartsAt_lt?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_lte?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_not?: InputMaybe<Scalars['DateTime']>;
  liveStreamStartsAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  spotifyPlaylistUrl?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_contains?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_exists?: InputMaybe<Scalars['Boolean']>;
  spotifyPlaylistUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spotifyPlaylistUrl_not?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_not_contains?: InputMaybe<Scalars['String']>;
  spotifyPlaylistUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  status_contains?: InputMaybe<Scalars['String']>;
  status_exists?: InputMaybe<Scalars['Boolean']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status_not?: InputMaybe<Scalars['String']>;
  status_not_contains?: InputMaybe<Scalars['String']>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtype?: InputMaybe<Scalars['String']>;
  subtype_contains?: InputMaybe<Scalars['String']>;
  subtype_exists?: InputMaybe<Scalars['Boolean']>;
  subtype_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtype_not?: InputMaybe<Scalars['String']>;
  subtype_not_contains?: InputMaybe<Scalars['String']>;
  subtype_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tags?: InputMaybe<Scalars['String']>;
  tags_contains?: InputMaybe<Scalars['String']>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_not?: InputMaybe<Scalars['String']>;
  tags_not_contains?: InputMaybe<Scalars['String']>;
  tags_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teacher_exists?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoseconds?: InputMaybe<Scalars['Int']>;
  videoseconds_exists?: InputMaybe<Scalars['Boolean']>;
  videoseconds_gt?: InputMaybe<Scalars['Int']>;
  videoseconds_gte?: InputMaybe<Scalars['Int']>;
  videoseconds_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  videoseconds_lt?: InputMaybe<Scalars['Int']>;
  videoseconds_lte?: InputMaybe<Scalars['Int']>;
  videoseconds_not?: InputMaybe<Scalars['Int']>;
  videoseconds_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  viewCount?: InputMaybe<Scalars['Int']>;
  viewCount_exists?: InputMaybe<Scalars['Boolean']>;
  viewCount_gt?: InputMaybe<Scalars['Int']>;
  viewCount_gte?: InputMaybe<Scalars['Int']>;
  viewCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  viewCount_lt?: InputMaybe<Scalars['Int']>;
  viewCount_lte?: InputMaybe<Scalars['Int']>;
  viewCount_not?: InputMaybe<Scalars['Int']>;
  viewCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CfTeacherNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTeacherNestedFilter>>>;
  BEID?: InputMaybe<Scalars['String']>;
  BEID_contains?: InputMaybe<Scalars['String']>;
  BEID_exists?: InputMaybe<Scalars['Boolean']>;
  BEID_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  BEID_not?: InputMaybe<Scalars['String']>;
  BEID_not_contains?: InputMaybe<Scalars['String']>;
  BEID_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTeacherNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  country?: InputMaybe<Scalars['String']>;
  country_contains?: InputMaybe<Scalars['String']>;
  country_exists?: InputMaybe<Scalars['Boolean']>;
  country_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_not?: InputMaybe<Scalars['String']>;
  country_not_contains?: InputMaybe<Scalars['String']>;
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName?: InputMaybe<Scalars['String']>;
  displayName_contains?: InputMaybe<Scalars['String']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName_not?: InputMaybe<Scalars['String']>;
  displayName_not_contains?: InputMaybe<Scalars['String']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  firstName_exists?: InputMaybe<Scalars['Boolean']>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName_not?: InputMaybe<Scalars['String']>;
  firstName_not_contains?: InputMaybe<Scalars['String']>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender?: InputMaybe<Scalars['String']>;
  gender_contains?: InputMaybe<Scalars['String']>;
  gender_exists?: InputMaybe<Scalars['Boolean']>;
  gender_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender_not?: InputMaybe<Scalars['String']>;
  gender_not_contains?: InputMaybe<Scalars['String']>;
  gender_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  heroImage_exists?: InputMaybe<Scalars['Boolean']>;
  image43_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  lastName_exists?: InputMaybe<Scalars['Boolean']>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastName_not?: InputMaybe<Scalars['String']>;
  lastName_not_contains?: InputMaybe<Scalars['String']>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  videoUrl?: InputMaybe<Scalars['String']>;
  videoUrl_contains?: InputMaybe<Scalars['String']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ClassFragment = { __typename: 'Class', displayName?: string, id?: string, beid?: string, name?: string, description?: string, classification?: string, type?: string, subtype?: string, level?: string, intensity?: string, videoseconds?: number, viewCount?: number, isPublic?: boolean, status?: string, publishedAt?: any, spotifyPlaylistUrl?: string, sys: { __typename?: 'Sys', id: string }, image?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, teacher?: { __typename: 'Teacher', beid?: string, slug?: string, displayName?: string, firstName?: string, lastName?: string, description?: string, gender?: string, country?: string, sys: { __typename?: 'Sys', id: string }, image?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, heroImage?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, image43?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } } } };

export type ClassMinimalFragment = { __typename?: 'Class', classification?: string, type?: string, videoseconds?: number, level?: string };

export type ContentfulImageFragment = { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } };

export type TeacherFragment = { __typename: 'Teacher', beid?: string, slug?: string, displayName?: string, firstName?: string, lastName?: string, description?: string, gender?: string, country?: string, sys: { __typename?: 'Sys', id: string }, image?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, heroImage?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, image43?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } } };

export type FetchSessionsQueryVariables = Exact<{
  limit: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  now: Scalars['DateTime'];
  order?: InputMaybe<Array<InputMaybe<ClassOrder>> | InputMaybe<ClassOrder>>;
  classifications?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  intensity?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  minDuration?: InputMaybe<Scalars['Int']>;
  maxDuration?: InputMaybe<Scalars['Int']>;
  teachers?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type FetchSessionsQuery = { __typename?: 'Query', classCollection?: { __typename?: 'ClassCollection', total: number, items: Array<{ __typename: 'Class', displayName?: string, id?: string, beid?: string, name?: string, description?: string, classification?: string, type?: string, subtype?: string, level?: string, intensity?: string, videoseconds?: number, viewCount?: number, isPublic?: boolean, status?: string, publishedAt?: any, spotifyPlaylistUrl?: string, sys: { __typename?: 'Sys', id: string }, image?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, teacher?: { __typename: 'Teacher', beid?: string, slug?: string, displayName?: string, firstName?: string, lastName?: string, description?: string, gender?: string, country?: string, sys: { __typename?: 'Sys', id: string }, image?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, heroImage?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } }, image43?: { __typename: 'Asset', title?: string, url?: string, width?: number, height?: number, sys: { __typename?: 'Sys', id: string } } } }> } };

export type FetchSessionsMinimalQueryVariables = Exact<{
  now: Scalars['DateTime'];
  classifications?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  intensity?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  minDuration?: InputMaybe<Scalars['Int']>;
  maxDuration?: InputMaybe<Scalars['Int']>;
  teachers?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type FetchSessionsMinimalQuery = { __typename?: 'Query', classCollection?: { __typename?: 'ClassCollection', total: number, items: Array<{ __typename?: 'Class', classification?: string, type?: string, videoseconds?: number, level?: string }> } };

export const ContentfulImageFragmentDoc = gql`
    fragment ContentfulImage on Asset {
  __typename
  sys {
    id
  }
  title
  url
  width
  height
}
    `;
export const TeacherFragmentDoc = gql`
    fragment Teacher on Teacher {
  __typename
  sys {
    id
  }
  beid
  slug
  displayName
  firstName
  lastName
  description
  gender
  country
  image {
    ...ContentfulImage
  }
  heroImage {
    ...ContentfulImage
  }
  image43 {
    ...ContentfulImage
  }
}
    ${ContentfulImageFragmentDoc}`;
export const ClassFragmentDoc = gql`
    fragment Class on Class {
  __typename
  sys {
    id
  }
  displayName
  id
  beid
  name
  description
  classification
  type
  subtype
  level
  intensity
  videoseconds
  viewCount
  isPublic
  status
  image {
    ...ContentfulImage
  }
  publishedAt
  teacher {
    ...Teacher
  }
  spotifyPlaylistUrl
}
    ${ContentfulImageFragmentDoc}
${TeacherFragmentDoc}`;
export const ClassMinimalFragmentDoc = gql`
    fragment ClassMinimal on Class {
  classification
  type
  videoseconds
  level
}
    `;
export const FetchSessionsDocument = gql`
    query fetchSessions($limit: Int!, $skip: Int, $now: DateTime!, $order: [ClassOrder], $classifications: [String], $types: [String], $levels: [String], $intensity: [String], $minDuration: Int, $maxDuration: Int, $teachers: [String]) {
  classCollection(
    limit: $limit
    skip: $skip
    order: $order
    where: {classification_in: $classifications, type_in: $types, level_in: $levels, intensity_in: $intensity, videoseconds_gt: $minDuration, videoseconds_lt: $maxDuration, teacher: {BEID_in: $teachers}, publishedAt_lte: $now}
  ) {
    total
    items {
      ...Class
    }
  }
}
    ${ClassFragmentDoc}`;

/**
 * __useFetchSessionsQuery__
 *
 * To run a query within a React component, call `useFetchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      now: // value for 'now'
 *      order: // value for 'order'
 *      classifications: // value for 'classifications'
 *      types: // value for 'types'
 *      levels: // value for 'levels'
 *      intensity: // value for 'intensity'
 *      minDuration: // value for 'minDuration'
 *      maxDuration: // value for 'maxDuration'
 *      teachers: // value for 'teachers'
 *   },
 * });
 */
export function useFetchSessionsQuery(baseOptions: Apollo.QueryHookOptions<FetchSessionsQuery, FetchSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSessionsQuery, FetchSessionsQueryVariables>(FetchSessionsDocument, options);
      }
export function useFetchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSessionsQuery, FetchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSessionsQuery, FetchSessionsQueryVariables>(FetchSessionsDocument, options);
        }
export type FetchSessionsQueryHookResult = ReturnType<typeof useFetchSessionsQuery>;
export type FetchSessionsLazyQueryHookResult = ReturnType<typeof useFetchSessionsLazyQuery>;
export type FetchSessionsQueryResult = Apollo.QueryResult<FetchSessionsQuery, FetchSessionsQueryVariables>;
export const FetchSessionsMinimalDocument = gql`
    query fetchSessionsMinimal($now: DateTime!, $classifications: [String], $types: [String], $levels: [String], $intensity: [String], $minDuration: Int, $maxDuration: Int, $teachers: [String]) {
  classCollection(
    limit: 9999
    where: {classification_in: $classifications, type_in: $types, level_in: $levels, intensity_in: $intensity, videoseconds_gt: $minDuration, videoseconds_lt: $maxDuration, teacher: {BEID_in: $teachers}, publishedAt_lte: $now}
  ) {
    total
    items {
      ...ClassMinimal
    }
  }
}
    ${ClassMinimalFragmentDoc}`;

/**
 * __useFetchSessionsMinimalQuery__
 *
 * To run a query within a React component, call `useFetchSessionsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSessionsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSessionsMinimalQuery({
 *   variables: {
 *      now: // value for 'now'
 *      classifications: // value for 'classifications'
 *      types: // value for 'types'
 *      levels: // value for 'levels'
 *      intensity: // value for 'intensity'
 *      minDuration: // value for 'minDuration'
 *      maxDuration: // value for 'maxDuration'
 *      teachers: // value for 'teachers'
 *   },
 * });
 */
export function useFetchSessionsMinimalQuery(baseOptions: Apollo.QueryHookOptions<FetchSessionsMinimalQuery, FetchSessionsMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSessionsMinimalQuery, FetchSessionsMinimalQueryVariables>(FetchSessionsMinimalDocument, options);
      }
export function useFetchSessionsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSessionsMinimalQuery, FetchSessionsMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSessionsMinimalQuery, FetchSessionsMinimalQueryVariables>(FetchSessionsMinimalDocument, options);
        }
export type FetchSessionsMinimalQueryHookResult = ReturnType<typeof useFetchSessionsMinimalQuery>;
export type FetchSessionsMinimalLazyQueryHookResult = ReturnType<typeof useFetchSessionsMinimalLazyQuery>;
export type FetchSessionsMinimalQueryResult = Apollo.QueryResult<FetchSessionsMinimalQuery, FetchSessionsMinimalQueryVariables>;